import { Link } from "react-router-dom";
import { categories, type Article } from "@/mocks/news";
import { formatViews } from "@/utils/format";

export function getCatName(slug: string): string {
  return categories.find((c) => c.slug === slug)?.name || "";
}

interface CardProps {
  article: Article;
  compact?: boolean;
}

/* 竖向文章卡片 */
export default function ArticleCard({ article: a, compact }: CardProps) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 hover:shadow-md transition-all">
      <Link to={`/news/${a.id}`} className="block" aria-label={a.title}>
        <div className="relative overflow-hidden">
          <img
            src={a.cover}
            alt={a.title}
            title={`${a.title} - 每日爆料`}
            className="w-full h-40 md:h-44 object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          {a.breaking && (
            <span className="absolute left-2 top-2 inline-flex items-center gap-1 bg-primary-600 text-background-50 text-[11px] px-2 py-0.5 rounded-sm font-medium">
              <i className="ri-flashlight-fill text-xs"></i>最新
            </span>
          )}
          <span className="absolute right-2 top-2 bg-foreground-950/60 text-background-50 text-[11px] px-2 py-0.5 rounded-sm">
            {getCatName(a.category)}
          </span>
        </div>
        <div className={compact ? "p-3" : "p-4"}>
          <h3 className={`${compact ? "text-sm" : "text-base md:text-[15px]"} font-heading font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors`}>
            {a.title}
          </h3>
          {!compact && (
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{a.summary}</p>
          )}
          <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              <span className="whitespace-nowrap">{a.time}</span>
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              <span className="whitespace-nowrap">{formatViews(a.views)}</span>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}

/* 横排文章条目（栏目列表 / 相关推荐） */
export function ArticleRow({ article: a }: { article: Article }) {
  return (
    <article className="group">
      <Link to={`/news/${a.id}`} className="flex flex-row gap-4 items-start">
        <div className="relative w-28 md:w-32 h-20 md:h-24 rounded-md overflow-hidden flex-shrink-0">
          <img
            src={a.cover}
            alt={a.title}
            title={`${a.title} - 每日爆料`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="text-primary-700 font-medium whitespace-nowrap">{getCatName(a.category)}</span>
            {a.hot && (
              <span className="inline-flex items-center gap-1 text-accent-700 whitespace-nowrap">
                <i className="ri-fire-fill"></i>热议
              </span>
            )}
            <span className="whitespace-nowrap">· {a.time}</span>
          </div>
          <h3 className="mt-1 text-[15px] font-heading font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
            {a.title}
          </h3>
          <p className="mt-1 text-sm text-foreground-600 line-clamp-1 hidden sm:block">{a.summary}</p>
        </div>
      </Link>
    </article>
  );
}